/* global google */

import { isDev, isProductionHost } from 'lib/env'

export const googleAPIKey = () => {
    return isProductionHost()
        ? process.env.PROD_GOOGLE_MAPS_API_KEY
        : process.env.GOOGLE_MAPS_API_KEY
}

export const googleReCAPTCHASiteKey = () => {
    return isProductionHost()
        ? process.env.PROD_GOOGLE_RECAPTCHA_SITE_KEY
        : process.env.GOOGLE_RECAPTCHA_SITE_KEY
}

export const isZeroLatLng = (latLng) => {
    return !latLng.lat && !latLng.lng
}

export const focusMapToPlace = (map, place) => {
    const ne = place.geometry.viewport.getNorthEast()
    const sw = place.geometry.viewport.getSouthWest()

    map.fitBounds(place.geometry.viewport)

    const boundingBoxPoints = [
        ne, new google.maps.LatLng(ne.lat(), sw.lng()),
        sw, new google.maps.LatLng(sw.lat(), ne.lng()), ne
    ]

    if (isDev()) {
        const boundingBox = new google.maps.Polyline({
            path: boundingBoxPoints,
            strokeColor: '#FF0000',
            strokeOpacity: 1.0,
            strokeWeight: 2
        })

        boundingBox.setMap(map)
    }
}
